import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import List from './facet_checkboxes';
import FacetCheckboxesShowMoreButton from './facet_checkboxes_show_more_button';
import LockedFacetModal from '../../modals/locked_facet_modal';

const { LP, $ } = window;

const FacetCheckbox = ({ facet, context, hideCount, showMore }) => {
  const [showLockedModal, setShowLockedModal] = useState(false);
  const [showInfoPopover, setShowInfoPopover] = useState(false);

  const inProvidersFacet = facet.key === 'provider_ids';
  const iconClass = facet.active ? 'selected fa-square-check' : 'fa-square';

  useEffect(() => {
    if (showInfoPopover) {
      $('[data-toggle="popover"]').popover({ sanitize: false });
    }
  }, [showInfoPopover]);

  const classNames = () => {
    const classes = ['lp-filter-item'];
    if (facet.expanded) {
      classes.push('open');
    }
    // hide the child that is the same as the parent.
    if (facet.isSelectAll) {
      classes.push('hide');
    }

    return classes.join(' ');
  };

  const handleMouseEnter = (e) => {
    if (['ccss', 'ss_ids'].includes(facet.key) && !facet.isParent && !facet.isSelectAll) {
      LP.module('CommonCoreInfo').showPopover(e.currentTarget, facet.id);
    }

    if (inProvidersFacet) {
      setShowInfoPopover(true);
    }
  };

  const handleMouseLeave = () => {
    if (inProvidersFacet) {
      setShowInfoPopover(false);
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (facet.locked) {
      setShowLockedModal(true);
      return;
    }

    if (!facet.disabled) {
      context.executeAction(LP.module('Searches').SearchActions.toggleFacet, {
        facet
      });
    }
  };

  const facetIcon = () => {
    if (facet.key === 'usage_permission_ids' && facet.title.indexOf('BY') !== -1) {
      return <i className="fa-brands fa-lg fa-creative-commons mr5" />;
    }
    return null;
  };

  const facetPopover = () => {
    if (!(inProvidersFacet && showInfoPopover && facet.info)) {
      return null;
    }

    const popoverId = `p-${facet.id.toString()}`;
    return (
      <i
        className={`lp-icon fa-regular fa-circle-info pool-info ${popoverId}`}
        data-toggle="popover"
        data-content={facet.info}
        data-html="true"
        data-placement="bottom"
        data-trigger="hover"
        data-container={`.${popoverId}`}
      />
    );
  };

  const renderMoreButton = () => {
    if (facet.isParent && facet.children.length > 1 && showMore) {
      return <FacetCheckboxesShowMoreButton facet={facet} context={context} />;
    }

    return null;
  };

  const children = () => {
    if (!facet.expanded) return null;

    return <List context={context} items={facet.children || []} isChildList={true} />;
  };

  const lockedFacetModal = () => {
    if (!(facet.locked && showLockedModal)) return null;

    return (
      <LockedFacetModal
        title={facet.title}
        handleClose={() => setShowLockedModal(false)}
      />
    );
  };

  return (
    <li
      key={facet.id}
      className={classNames()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className="flex items-center justify-between facet-text-flex">
        <span
          className={`facet-text ${facet.disabled ? 'facet-disabled' : ''}`}
          onClick={handleClick}
        >
          <span className={facet.disabled ? 'disabled' : ''}>
            <i className={`fa-regular facet-checkbox-box ${iconClass}`} />
            {facetIcon()}
            <span className="text mr-1">{facet.title}</span>
            {!hideCount && (
              <span className="text-gray-500 text-xs">{facet.formattedCount()}</span>
            )}
          </span>
          {facetPopover()}
        </span>
        {renderMoreButton()}
      </span>
      {children()}
      {lockedFacetModal()}
    </li>
  );
};

FacetCheckbox.propTypes = {
  facet: PropTypes.object,
  context: PropTypes.object,
  hideCount: PropTypes.bool,
  showMore: PropTypes.bool
};

export default FacetCheckbox;
